import { useContext, useEffect } from 'react';
import AuthContext from '../../context/AuthProvider';
import { initializeCleverTap, syncCleverTapUser, notifyCleverTapPageChanged } from '../../utils/clevertap';

export default function CleverTapBootstrap() {
  const { datalogin } = useContext(AuthContext) as any;

  useEffect(() => {
    initializeCleverTap();
  }, []);

  useEffect(() => {
    if (!datalogin) {
      return;
    }

    syncCleverTapUser(datalogin);

    // This is necessary to ensure the correct campaigns are shown after login.
    notifyCleverTapPageChanged();
  }, [datalogin]);

  return null;
}
